import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { TypedMemo } from '../../common/types';
import { SMLSettingsTabBlock, SMLSettingsTabDef, SMLSettingsTabId } from '../tabs/types';
import { Panel } from '../../music24/components/primitives/Panel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Settings tabs; each part uses its own slice of it */
import styles from './SMLSettingsViewRenderer.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface Props {
  tabs: SMLSettingsTabDef[];
  onSelect: (tabId: SMLSettingsTabId) => void;
}

/** Below the md breakpoint: the tabs as an index, one card per block (design settings-redesign a2). */
const SettingsMobileIndexComponent: React.FC<Props> = ({ tabs, onSelect }) => {
  const intl = useIntl();
  const blocks = useMemo(() => {
    const grouped: { block: SMLSettingsTabBlock; tabs: SMLSettingsTabDef[] }[] = [];
    tabs.forEach((tab) => {
      const last = grouped[grouped.length - 1];
      if (last?.block === tab.block) {
        last.tabs.push(tab);
      } else {
        grouped.push({ block: tab.block, tabs: [tab] });
      }
    });
    return grouped;
  }, [tabs]);

  return (
    <div className={styles.mobileIndex}>
      {blocks.map((group) => (
        <Panel key={group.block} className={styles.mobileBlock}>
          {group.tabs.map((tab) => (
            <button key={tab.id} type="button" className={styles.mobileRow} onClick={() => onSelect(tab.id)}>
              <span className={styles.mobileIcon}>
                <FontAwesomeIcon icon={tab.icon} fixedWidth />
              </span>
              <span className={styles.mobileLabel}>{intl.formatMessage(tab.label)}</span>
              <FontAwesomeIcon icon={faChevronRight} className={styles.mobileChevron} />
            </button>
          ))}
        </Panel>
      ))}
    </div>
  );
};

export const SettingsMobileIndex = TypedMemo(SettingsMobileIndexComponent);
